import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col
} from '@lockerpm/design';

import managePlansComponents from "./components";

import global from "../../../config/global";
import common from "../../../utils/common";

const ManagePlans = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentPage = common.getRouterByLocation(location);
  const {
    PlanTabs,
    ChoosePlanCard,
    ChoosePlanHeader,
    PlanPayment
  } = managePlansComponents;

  const planPeriod = global.constants.PLAN_PERIOD;
  const planTypes = global.constants.PLANS;

  const plan = useSelector((state) => state.payment.plan);
  const plans = useSelector((state) => state.resource.plans);

  const [selectedPlanDuration, setSelectedPlanDuration] = useState(planPeriod.YEARLY);
  const [selectedMenu, setSelectedMenu] = useState(currentPage.query?.tab || 'choose_plan');
  const [selectedPlan, setSelectedPlan] = useState({
    half_yearly_price: {},
    price: {},
    yearly_price: {},
    name: ''
  });

  useEffect(() => {
    if (plan) {
      const planInfo = plans.find(p => p.alias === currentPage.query?.plan);
      if (currentPage.query?.period) {
        setSelectedPlanDuration(currentPage.query?.period)
      } else {
        setSelectedPlanDuration(plan?.duration || planPeriod.YEARLY)
      }
      if (currentPage.query?.plan && planInfo) {
        handleSwitchPlan(planInfo)
        return
      }
    }
  }, [plan])

  const selectedPeriod = useMemo(() => {
    switch (selectedPlanDuration) {
      case planPeriod.YEARLY:
        return {
          label: 'plans.price.yearly',
          value: 12,
          duration: planPeriod.YEARLY
        }
      default:
        return {
          label: 'plans.price.monthly',
          value: 1,
          duration: planPeriod.MONTHLY
        }
      }
  }, [selectedPlanDuration])

  const handleSwitchPlan = (sPlan, silent = false) => {
    const confirmMessage = t('manage_plans.switch_plan', {
      currentPlan: plan?.name,
      chosenPlan: sPlan?.name,
      currentPeriod: t(`common.${plan?.duration}`),
      chosenPeriod: t(`common.${selectedPeriod.duration}`)
    })

    const switchPlan = () => {
      setSelectedPlan(sPlan)
      changeMenu('payment')
    }

    const shouldShowConfirmation = (plan?.alias !== sPlan.alias || plan?.duration !== selectedPeriod.duration) && !silent;

    if (shouldShowConfirmation) {
      global.confirm(() => switchPlan(), {
        content: confirmMessage,
        okText: t('button.proceed'),
        okButtonProps: { danger: false },
      })
    } else {
      switchPlan()
    }
  }

  const changeMenu = (menu) => {
    global.navigate(currentPage.name, currentPage.params, { tab: menu })
    setSelectedMenu(menu)
  }

  return (
    <div className="manage-plans layout-content" onScroll={(e) => common.scrollEnd(e, false, 0, () => {})}>
      <PlanTabs
        selectedMenu={selectedMenu}
        onChange={changeMenu}
      />
      {
        selectedMenu === 'choose_plan' && <div className="choose-plan">
          <ChoosePlanHeader
            planPeriod={planPeriod}
            selectedPeriod={selectedPeriod}
            setSelectedPlanDuration={setSelectedPlanDuration}
          />
          <Row gutter={[24, 24]} className="mt-4">
            {
              plans.map((p, index) => <Col xl={8} lg={8} key={index} span={24}>
                <ChoosePlanCard
                  planInfo={p}
                  planTypes={planTypes}
                  planPeriod={planPeriod}
                  selectedPeriod={selectedPeriod}
                  setSelectedPlanDuration={setSelectedPlanDuration}
                  onSwitchPlan={handleSwitchPlan}
                />
              </Col>)
            }
          </Row>
        </div>
      }
      {
        selectedMenu === 'payment' && <div className="payment">
          <PlanPayment
            planTypes={planTypes}
            planPeriod={planPeriod}
            selectedPeriod={selectedPeriod}
            selectedPlan={selectedPlan}
            setSelectedPlanDuration={setSelectedPlanDuration}
            onSwitchPlan={handleSwitchPlan}
          />
        </div>
      }
    </div>
  );
}

export default ManagePlans;